import { Button, Form, Input, notification, Upload } from 'antd';
import { useEffect, useState } from 'react';
import { FaUpload } from 'react-icons/fa';
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import { ConnectedUserEntity } from '../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../entities/detenteur.entity';
import { ORANGE, PRIMARY, YELLOW } from '../../../../shared/colors';
import { createDetenteur, updateDetenteur } from '../network';

const Container = styled.div`
  color: var(--mt-text);
  font-family: Poppins-R;

  .client-form {
    display: flex;
    flex-direction: column;
    gap: 14px;
  }

  .client-form .ant-form-item {
    margin-bottom: 0;
  }

  .form-hero {
    position: relative;
    overflow: hidden;
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    gap: 16px;
    padding: 18px;
    border: 1px solid rgba(255, 178, 0, 0.24);
    border-radius: 14px;
    background:
      radial-gradient(
        circle at 92% 18%,
        rgba(255, 178, 0, 0.18),
        transparent 26%
      ),
      linear-gradient(135deg, #091821 0%, ${PRIMARY} 48%, #111418 100%);
    color: #fff;
    box-shadow: 0 22px 48px rgba(2, 8, 12, 0.2);
  }

  .form-hero::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(
      90deg,
      rgba(255, 69, 35, 0.16),
      transparent 38%
    );
    pointer-events: none;
  }

  .form-hero > * {
    position: relative;
    z-index: 1;
  }

  .eyebrow {
    display: block;
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.08em;
    text-transform: uppercase;
  }

  .form-hero h2,
  .form-hero p {
    margin: 0;
  }

  .form-hero h2 {
    margin-top: 5px;
    font-family: Poppins-B;
    font-size: 22px;
    color: #fff;
    text-shadow: 0 2px 16px rgba(0, 0, 0, 0.35);
  }

  .form-hero p {
    max-width: 470px;
    margin-top: 6px;
    color: rgba(255, 255, 255, 0.82);
    font-size: 13px;
    line-height: 1.5;
  }

  .client-chip {
    align-self: start;
    min-width: 128px;
    padding: 11px 12px;
    border: 1px solid rgba(255, 178, 0, 0.28);
    border-radius: 12px;
    background: rgba(2, 8, 12, 0.46);
    box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
  }

  .client-chip span {
    display: block;
    color: rgba(255, 255, 255, 0.62);
    font-size: 11px;
    text-transform: uppercase;
  }

  .client-chip strong {
    display: block;
    margin-top: 5px;
    color: #fff;
    font-family: Poppins-B;
    font-size: 14px;
  }

  .form-section {
    padding: 16px;
    border: 1px solid var(--mt-border);
    border-radius: 12px;
    background: var(--mt-card);
  }

  .section-head {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 12px;
    margin-bottom: 14px;
    padding-bottom: 11px;
    border-bottom: 1px solid var(--mt-border);
  }

  .section-head h3 {
    margin: 0;
    color: ${YELLOW};
    font-family: Poppins-B;
    font-size: 15px;
    text-transform: uppercase;
  }

  .section-head span {
    color: var(--mt-muted);
    font-size: 12px;
  }

  .field-grid {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 12px;
  }

  .field-grid.single {
    grid-template-columns: 1fr;
  }

  .ant-form-item-label > label {
    color: var(--mt-muted);
    font-family: Poppins-B;
    font-size: 11px;
    letter-spacing: 0.04em;
    text-transform: uppercase;
  }

  .ant-input {
    min-height: 40px;
    border-color: var(--mt-border);
    border-radius: 9px;
    background: var(--mt-surface);
    color: var(--mt-text);
    box-shadow: none;
  }

  .ant-input:hover,
  .ant-input:focus {
    border-color: color-mix(in srgb, ${ORANGE} 56%, var(--mt-border));
    box-shadow: 0 0 0 2px color-mix(in srgb, ${ORANGE} 12%, transparent);
  }

  .ant-input::placeholder {
    color: color-mix(in srgb, var(--mt-muted) 68%, transparent);
  }

  .upload-panel {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto;
    align-items: center;
    gap: 14px;
    padding: 14px;
    border: 1px dashed var(--mt-border);
    border-radius: 12px;
    background: var(--mt-surface);
  }

  .upload-panel strong {
    display: block;
    color: var(--mt-text);
    font-family: Poppins-B;
    font-size: 14px;
  }

  .upload-panel p {
    margin: 4px 0 0;
    color: var(--mt-muted);
    font-size: 12px;
  }

  .upload-button {
    height: 38px;
    border-color: color-mix(in srgb, ${ORANGE} 45%, var(--mt-border));
    border-radius: 999px;
    color: ${ORANGE};
    font-family: Poppins-B;
  }

  .form-actions {
    position: sticky;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    gap: 10px;
    margin: 4px -2px -2px;
    padding: 14px 2px 2px;
    background: linear-gradient(
      180deg,
      color-mix(in srgb, var(--mt-card) 0%, transparent),
      var(--mt-card) 40%
    );
  }

  .ghost-action,
  .primary-action {
    min-width: 132px;
    height: 40px;
    border-radius: 999px;
    font-family: Poppins-B;
  }

  .ghost-action {
    border-color: var(--mt-border);
    background: var(--mt-surface);
    color: var(--mt-text);
  }

  .primary-action {
    border-color: ${ORANGE};
    background: ${ORANGE};
    color: #fff;
    box-shadow: 0 14px 28px color-mix(in srgb, ${ORANGE} 24%, transparent);
  }

  .primary-action:hover,
  .primary-action:focus {
    border-color: ${ORANGE} !important;
    background: ${ORANGE} !important;
    color: #fff !important;
  }

  @media (max-width: 720px) {
    .form-hero,
    .field-grid,
    .upload-panel {
      grid-template-columns: 1fr;
    }
  }
`;

export const ClientForm = ({
  clientToUpdate,
  setShowDrawer,
  getNewClient,
}: {
  clientToUpdate?: DetenteurEntity;
  setShowDrawer: (b: boolean) => void;
  getNewClient: (part: DetenteurEntity) => void;
}) => {
  const [form] = Form.useForm();
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (!clientToUpdate) {
      form.resetFields();
    } else {
      form.setFieldsValue(clientToUpdate);
    }
  }, [clientToUpdate, form]);

  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;

  const handleFinish = async (data) => {
    setIsLoading(true);
    if (clientToUpdate === undefined) {
      data.partenaire = connectedUser.partenaire.url;
      data.agence = connectedUser.agence.url;
      data.asset_manager = connectedUser.manager.url;
      data.createur = connectedUser.url;
      data.piece_identite = data.piece_identite?.fileList[0]?.originFileObj;

      await createDetenteur(data).then(({ data, statusCode }) => {
        if (statusCode?.toString()[0] === '2') {
          notification.success({
            message: 'Succès',
            description: 'Le client a été créé avec succès',
          });
          getNewClient(data);
          setShowDrawer(false);
        } else {
          notification.info({
            message: 'Erreur',
            description: data.message,
          });
        }
        setIsLoading(false);
      });
    } else {
      const { piece_identite, ...dataToUpdate } = data;
      await updateDetenteur(clientToUpdate.url, dataToUpdate).then(
        ({ data, statusCode }) => {
          if (statusCode?.toString()[0] === '2') {
            notification.success({
              message: 'Succès',
              description: 'Le client a été mis à jour avec succès',
            });
            setShowDrawer(false);
          } else {
            notification.info({
              message: 'Erreur',
              description: data.message,
            });
          }
          setIsLoading(false);
        },
      );
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Form
        className='client-form'
        layout='vertical'
        form={form}
        initialValues={clientToUpdate}
        onFinish={handleFinish}
      >
        <section className='form-hero'>
          <div>
            <span className='eyebrow'>
              {clientToUpdate ? 'Modification client' : 'Nouveau client'}
            </span>
            <h2>{getClientName(clientToUpdate)}</h2>
            <p>
              Renseignez les informations de référence qui alimentent la
              clientèle, les contrôles KYC et les opérations de portefeuille.
            </p>
          </div>
          <div className='client-chip'>
            <span>Référent</span>
            <strong>{clientToUpdate?.code_referent || 'À créer'}</strong>
          </div>
        </section>

        <section className='form-section'>
          <div className='section-head'>
            <h3>Identité</h3>
            <span>Informations civiles du détenteur</span>
          </div>
          <div className='field-grid'>
            {!clientToUpdate && (
              <Form.Item
                label='Code référent'
                name='code_referent'
                rules={[
                  {
                    required: true,
                    message: 'Entrez le code référent du client',
                  },
                ]}
              >
                <Input placeholder='Ex. 1010' />
              </Form.Item>
            )}
            <Form.Item
              label='Nom'
              name='nom'
              rules={[
                {
                  required: true,
                  message: 'Entrez le nom',
                },
              ]}
            >
              <Input placeholder='Nom du client' />
            </Form.Item>
            <Form.Item
              label='Prénom'
              name='prenom'
              rules={[
                {
                  required: true,
                  message: 'Entrez le prénom',
                },
              ]}
            >
              <Input placeholder='Prénom du client' />
            </Form.Item>
            <Form.Item
              label='Nationalité'
              name='nationalite'
              rules={[
                {
                  required: true,
                  message: 'Entrez la nationalité',
                },
              ]}
            >
              <Input placeholder='Nationalité' />
            </Form.Item>
          </div>
        </section>

        <section className='form-section'>
          <div className='section-head'>
            <h3>Contact</h3>
            <span>Coordonnées et adresse opérationnelle</span>
          </div>
          <div className='field-grid'>
            <Form.Item
              label='Email'
              name='email'
              rules={[
                {
                  required: true,
                  message: 'Entrez une adresse mail valide',
                },
              ]}
            >
              <Input placeholder='client@exemple.com' />
            </Form.Item>
            <Form.Item label='Contact' name='mobile'>
              <Input placeholder='Téléphone' />
            </Form.Item>
            <Form.Item
              label='Adresse'
              name='adresse'
              rules={[
                {
                  required: true,
                  message: "Entrez l'adresse",
                },
              ]}
            >
              <Input placeholder='Adresse complète' />
            </Form.Item>
          </div>
        </section>

        {!clientToUpdate && (
          <section className='form-section'>
            <div className='section-head'>
              <h3>Pièce client</h3>
              <span>Document initial optionnel</span>
            </div>
            <Form.Item label="Pièce d'identité" name='piece_identite'>
              <div className='upload-panel'>
                <div>
                  <strong>Ajouter un document d'identité</strong>
                  <p>
                    Le dossier KYC complet reste disponible dans l'espace
                    conformité.
                  </p>
                </div>
                <Upload name='piece' showUploadList>
                  <Button
                    className='upload-button'
                    icon={<FaUpload style={{ marginRight: 8 }} />}
                  >
                    Sélectionner
                  </Button>
                </Upload>
              </div>
            </Form.Item>
          </section>
        )}

        <div className='form-actions'>
          <Button
            className='ghost-action'
            onClick={() => setShowDrawer(false)}
          >
            Annuler
          </Button>
          <Button
            htmlType='submit'
            loading={isLoading}
            className='primary-action'
          >
            {clientToUpdate ? 'Mettre à jour' : 'Créer le client'}
          </Button>
        </div>
      </Form>
    </Container>
  );
};

const getClientName = (client?: DetenteurEntity) => {
  const name = `${client?.nom || ''} ${client?.prenom || ''}`.trim();
  return name || 'Dossier client';
};
